import { Injectable } from '@angular/core';
import {PlataformasDigitalesValidacionesFacetec} from "../_models/plataformas-digitales-validaciones-facetec";
import {AppSettings} from "../../proyect.conf";
import { HttpClient } from "@angular/common/http";
import {AutenticacionService} from "./autenticacion.service";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PlataformasDigitalesValidacionesFacetecService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/plataformasDigitalesValidacionesFacetec';

  private rutServicioGestionado = AppSettings.rutServiciosAUTOGES + '/api/plataformasDigitalesValidacionesFacetec';

  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec ) );
  }

  obtenerPorIdPlataDigiVal( idPlataDigiVal: string ) {
    return this.httpClient.get( this.rutServicioGestionado + '/plataformaDigitalValidacion/' + idPlataDigiVal + '/enabled' ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec[] ) );
  }

  crear( regCrear: PlataformasDigitalesValidacionesFacetec ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec ) );
  }

  actualizar( regActualizar: PlataformasDigitalesValidacionesFacetec ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec ) );
  }

  bulk( dato: PlataformasDigitalesValidacionesFacetec[] ) {
    dato.forEach(s=>{
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient.post( this.rutServicio + '/bulk', dato ).pipe( map( res => res as PlataformasDigitalesValidacionesFacetec[] ) );
  }
}
